import { getPrepaymentPercents } from '@/entities/prepayment';
import type { Product } from '@/entities/product';
import { SERP_PREPAYMENTS_FILTER_TEXTS } from '../config/texts';
import type { SerpFilterOption, SerpProduct, SerpResultsDictionaries } from '../model/types';

export function getProductPrepaymentsFilterKeys(product: Product): string[] {
  return getPrepaymentPercents(product).map(String);
}

export function getPrepaymentsFilterKeys(products: readonly SerpProduct[]): string[] {
  const keys = new Set<string>();

  for (const serpProduct of products) {
    for (const product of serpProduct.products) {
      for (const key of getProductPrepaymentsFilterKeys(product)) keys.add(key);
    }
  }

  return [...keys];
}

export function getDictionaryPrepaymentsFilterKeys(prepayments: SerpResultsDictionaries['prepayments']): string[] {
  return getPrepaymentPercents({ firstPaymentDefinitions: [...prepayments] }).map(String);
}

function formatPrepaymentsFilterLabel(key: string): string {
  return `${key}% ${SERP_PREPAYMENTS_FILTER_TEXTS.optionSuffix}`;
}

export function getPrepaymentsFilterOptions(keys: readonly string[]): SerpFilterOption[] {
  return [...new Set(keys)]
    .sort((first, second) => Number(first) - Number(second))
    .map((key) => ({ key, label: formatPrepaymentsFilterLabel(key) }));
}
